(function () {
  document.querySelectorAll('[data-sp-viewers]').forEach((container) => {
    const countEl = container.querySelector('[data-sp-viewers-count]');
    if (!countEl) return;

    let viewers = Number(countEl.textContent) || 10;

    const update = () => {
      viewers += [1, -1, 2, -2][Math.floor(Math.random() * 4)];
      viewers = Math.max(4, Math.min(32, viewers));
      countEl.textContent = viewers;
    };

    setInterval(update, 15000);
  });
})();